var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"router":"","default-active":_vm.$route.path}},_vm._l((_vm.menuTree),function(item){return _c('menu-item',{key:item.url,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }